import React, { useEffect, useState } from 'react';
import { CForm, CFormLabel, CFormInput, CButton, CListGroup, CListGroupItem, CFormCheck, CLink } from '@coreui/react';
import AsyncSelect from 'react-select/async';
import Select from 'react-select';
import { useConvertToLocalTime } from 'src/components/store/useConvertToLocalTime';
import { Link, useNavigate } from 'react-router-dom';


// Компонент з загальними даними про роботу
const JobData = (props) => {
    // console.log('JobData props', props);

    const [isDisabledCancelBtn, setIsDisabledCancelBtn] = useState(true);
    const [isDisabledPutBtn, setIsDisabledPutBtn] = useState(true);
    const navigate = useNavigate()

    // Відлідковувати дані для блокування/розблокування кнопок
    useEffect(() => {
        // Заблокувати кнопку "Відмінити зміни"
        if ((props.selectedOptionFactories?.label === props.data.factory.name) && (props.selectedEngineer?.label === props.data.engineer.name)) {
            setIsDisabledCancelBtn(true);
        } else {
            setIsDisabledCancelBtn(false);
        }

        // Заблокувати кнопку "Зберегти"
        if ((props.selectedOptionFactories === null || props.selectedEngineer === null) ||
            ((props.selectedOptionFactories?.label === props.data.factory.name) && (props.selectedEngineer?.label === props.data.engineer.name))) {
            setIsDisabledPutBtn(true);
        } else {
            setIsDisabledPutBtn(false);
        }
    }, [props.data, props.selectedOptionFactories, props.selectedEngineer]);

    console.log('props', props)

    return (
        <>

            <div className="mb-3">
                <CFormLabel htmlFor="exampleFormControlInput1">Контрагент</CFormLabel>
                <Link to={`/accounts/update/${props.data.account.id}`}
                // style={{ textDecoration: 'none' }}
                >
                    <CFormInput
                        type="text"
                        id="exampleFormControlInput1"
                        value={props.data.account.name}
                        // disabled={true}
                        readOnly
                        autoComplete="off"
                        style={{ cursor: 'pointer', backgroundColor: '#e9ecef' }}

                    />
                </Link>
            </div >

            <div className="mb-3">
                <CFormLabel htmlFor="exampleFormControlInput1">Назва роботи</CFormLabel>
                <CFormInput
                    type="text"
                    id="exampleFormControlInput1"
                    value={props.data.name}
                    autoComplete="off"
                    disabled={true}
                />
            </div>

            <div className="mb-3">
                <CFormLabel htmlFor="exampleFormControlInput2">Опис</CFormLabel>
                <CFormInput
                    type="text"
                    id="exampleFormControlInput2"
                    value={props.data.description}
                    autoComplete="off"
                    disabled={true}
                />
            </div>

            {/* Перший горизонтальний блок */}
            <div style={{
                display: 'flex',
                //  justifyContent: 'space-between',
                gap: '15px'
            }}>
                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput2">Дата початку</CFormLabel>
                    <CFormInput
                        type="text"
                        id="exampleFormControlInput2"
                        value={props.data?.dateStart ? useConvertToLocalTime(props.data.dateStart) : "❌"}
                        autoComplete="off"
                        disabled={true}
                    />
                </div>

                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput2">Дата закінчення</CFormLabel>
                    <CFormInput
                        type="text"
                        id="exampleFormControlInput2"
                        value={props.data?.dateEnd ? useConvertToLocalTime(props.data.dateEnd) : "❌"}
                        autoComplete="off"
                        disabled={true}
                    />
                </div>

                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput2">Дата створення</CFormLabel>
                    <CFormInput
                        type="text"
                        id="exampleFormControlInput2"
                        value={props.data?.dateEntered ? useConvertToLocalTime(props.data.dateEntered) : "❌"}
                        autoComplete="off"
                        disabled={true}
                    />
                </div>

                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput2">Дата початку аудиту</CFormLabel>
                    <CFormInput
                        type="text"
                        id="exampleFormControlInput2"
                        value={props.data?.dateStartAudit ? useConvertToLocalTime(props.data.dateStartAudit) : "❌"}
                        autoComplete="off"
                        disabled={true}
                    />
                </div>

                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput2">Дата аудиту</CFormLabel>
                    <CFormInput
                        type="text"
                        id="exampleFormControlInput2"
                        value={props.data?.dateAudit ? useConvertToLocalTime(props.data.dateAudit) : "❌"}
                        autoComplete="off"
                        disabled={true}
                    />
                </div>

                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput2">Дата відправки в 1С</CFormLabel>
                    <CFormInput
                        type="text"
                        id="exampleFormControlInput2"
                        value={props.data?.dateSendC1 ? useConvertToLocalTime(props.data.dateSendC1) : "❌"}
                        autoComplete="off"
                        disabled={true}
                    />
                </div>
            </div>

            {/* кінець першого горизонтального блоку */}

            {/* другий горизонтальний блок */}
            <div style={{ display: 'flex', gap: '20px' }}>
                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput1">Підрозділ</CFormLabel>
                    <AsyncSelect
                        cacheOptions
                        loadOptions={props.loadOptionsFactories}
                        defaultOptions
                        value={props.selectedOptionFactories}
                        onChange={props.handleChangeFactories}
                        isDisabled={props.isDisabledAll || props.isDisabledChange}
                    />
                </div>

                <div className="mb-3">
                    <CFormLabel htmlFor="exampleFormControlInput1">Відповідальний інженер</CFormLabel>
                    <Select
                        cacheOptions
                        options={props.selectedOptionEngineers}
                        defaultOptions
                        value={props.selectedEngineer}
                        onChange={props.handleChangeEngineers}
                        className="flex-grow-1"
                        isDisabled={props.isDisabledAll || props.isDisabledChange}
                    />
                </div>
            </div>
            {/* кінець другого горизонтального блоку */}

            {/* props.isDisabledAll={true} - Заблокувати можливу зміну, оскільки дані вже вневені в 1С */}
            {
                !props.isDisabledAll &&
                <>
                    <CButton color="success" className="me-3" onClick={(event) => props.handleSubmit(event)} disabled={isDisabledPutBtn}>
                        Зберегти
                    </CButton>
                    <CButton color="secondary" onClick={() => props.cancelChange()} disabled={isDisabledCancelBtn}>
                        Відмінити зміни
                    </CButton>
                </>
            }
        </>
    );
};

export default JobData;